import styled from 'styled-components';
import { Box } from '@mui/material';

export const ModalContentWrapper = styled(Box)<{
  $height?: string;
  $width?: string;
  $maxWidth?: string;
  $maxHeight?: string;
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: ${({ $width }) => $width || '400px'};
  height: ${({ $height }) => $height || '300px'};
  max-width: ${({ $maxWidth }) => $maxWidth || 'none'};
  max-height: ${({ $maxHeight }) => $maxHeight || 'none'};
  overflow: auto;
  background-color: #fff;
  border: 2px solid #000;
  padding: 1%;
  gap: 10px;

  .full {
    width: 100%;
    font-size: 14px;
  }

  .MuiInputLabel-formControl {
    font-size: 14px;
  }

  .MuiInput-input {
    font-size: 14px;
  }

  .half {
    width: 48%;
    font-size: 14px;
  }

  &.confirm {
    padding: 20px;
    font-family: Arial, Helvetica, sans-serif;
    gap: 10px;
    border-radius: 10px;
    border: 1px solid #fff;

    .title {
      font-size: 2.4em;
      height: 22px;
      font-weight: bold;
      color: #666;
    }

    .subtitle {
      font-size: 1.6em;
      color: #666;
      display: flex;
      align-items: center;
    }

    .full {
      font-size: 20px;
      button {
        font-size: 16px;
      }
    }

    .MuiInputLabel-formControl {
      font-size: 12px;
    }

    .MuiInput-input {
      font-size: 12px;
    }
  }
`;

export const ConfirmButton = styled.button`
  background: #333;
  border: none;
  border-radius: 5px;
  color: #eee;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  margin-right: 10px;
  outline: none;
  padding: 6px 18px;
`;

export const Textarea = styled.textarea`
  font-family: Rubik, sans-serif;
  resize: none;
  height: 60px;
  width: 100%;
  border-radius: 0.5rem;
  padding: 0.5rem;
  &:focus {
    outline: none;
    border-color: rgb(139, 211, 0);
    box-shadow: 0 0 0 1px rgb(139, 211, 0);
  }
`;
